// src/components/Auth/RegisterForm.js
import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios'; // Tu instancia de Axios

function RegisterForm() {
    const [numeroApartamento, setNumeroApartamento] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccess('');

        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        try {
            const response = await axiosInstance.post('/Auth/register', {
                numeroApartamento,
                password,
            });
            setSuccess('Registro exitoso. Ahora puedes iniciar sesión.');
            console.log('Registro exitoso:', response.data);
            // Opcional: Redirigir automáticamente después de un tiempo
            setTimeout(() => {
                navigate('/login');
            }, 2000);
        } catch (err) {
            console.error('Error de registro:', err.response ? err.response.data : err.message);
            setError(err.response?.data?.message || 'Error al registrar. Inténtalo de nuevo.');
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
                margin="normal"
                required
                fullWidth
                id="numeroApartamento"
                label="Número de Apartamento"
                name="numeroApartamento"
                autoComplete="apartment-number"
                autoFocus
                value={numeroApartamento}
                onChange={(e) => setNumeroApartamento(e.target.value)}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirmar Contraseña"
                type="password"
                id="confirmPassword"
                autoComplete="new-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {error && (
                <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    {error}
                </Typography>
            )}
            {success && (
                <Typography color="primary" variant="body2" sx={{ mt: 1 }}>
                    {success}
                </Typography>
            )}
            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
            >
                Registrarse
            </Button>
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
                ¿Ya tienes cuenta?{' '}
                <Link to="/login" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button variant="text" color="primary" sx={{ p: 0, minWidth: 0 }}>
                        Inicia Sesión
                    </Button>
                </Link>
            </Typography>
        </Box>
    );
}

export default RegisterForm;